// extracted by mini-css-extract-plugin
export default {"marcWrapper":"marcWrapper---f9WG7","marc":"marc---DZ1Dx"};